import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import history from '../../Routers/history';
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import { toggleSideBar, updateCurrentTabStatus, updateBotValue, getGenericData, blockUiFun} from '../../Redux/Actions/uiActions';

import './BodyTabs.scss';
import Cards from '../../Components/Cards';
import CustomCss from '../../Components/CustomCss';
import CustomJs from '../../Components/CustomJs';
import Dashboard from '../../Components/Dashboard';
import DefaultComp from '../../Components/DefaultComp';
import EmptyComp from '../../Components/EmptyComp';
import Frameworks from '../../Components/Frameworks';
import ImagesComp from '../../Components/ImagesComp';
import MessagesText from '../../Components/MessagesText';
import UiSettings from '../../Components/UiSettings';
import { bindActionCreators } from 'redux';
import Settings from '../../Components/Settings';
import { Modal } from "react-ui-lib";
import TestingComp from '../../Components/TestingComp';
import SelectionView from '../../Components/SelectionView';

class BodyTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentActiveTabId: 'chatbot',
            checkMatch: false,
            isOpen: false
        }
        this.searchedData = []
    }

    componentDidMount() {
        if(!this.props.isCustomBot && this.props.id) {
            history.push(`/${this.props.id}`)
        } else if (this.props.isCustomBot && this.props.id) {
            this.selectedTab = this.props.location.pathname.split('/')[2];
            let tempArray = this.props.tabListArray.filter(elem => {
                return elem.toLowerCase().replace(/ /g,'').replace(/\//g,'') === this.selectedTab;
            });
            if(tempArray.length) {
                this.props.updateCurrentTabStatus(this.selectedTab);
            } else if(this.selectedTab === 'settings' || history?.location?.pathname === '/bot-list') {
                this.props.updateCurrentTabStatus(this.selectedTab);
            }
            else {
                history.push(`/${this.props.id}/chatbot`)
            }
            // setTimeout(() => {
            //     this.checkNewUpdatedValues();
            // }, 1000);
        }
    }

    checkNewUpdatedValues = () => {
        this.searchedData = [];
        let currentBotDeatails = this.props.availableBotList.find(elem => elem.displayName === this.props.selectedBot);
        if(!currentBotDeatails) return;
        if(!this.props.isCustomBot) return;
        if(!this.props.editableBotData.CUSTOM_BOT_UI.VALUE) return;
        if((this.props.currentLanguage !== this.props.genericBotData.langISO && currentBotDeatails.langISO !== this.props.genericBotData.langISO) || this.props.editableBotData.sourceLangISO !== this.props.genericBotData.langISO) {
            this.props.getGenericData(this.props.editableBotData.sourceLangISO || this.props.currentLanguage, (res) => {
                this.searchedData = this.searchInObject([], res, this.props.editableBotData);
                if(this.searchedData.length) {
                    this.props.blockUiFun(false);
                    this.toggleModal();
                } else {
                    this.props.blockUiFun(false);
                }
                this.updateBot(this.props.editableBotData);
            });
        } else {
            this.searchedData = this.searchInObject([], this.props.genericBotData, this.props.editableBotData);
            if(!this.searchedData.length) {
                if( this.props.editableBotData.CHATBOT && this.props.editableBotData.CHATBOT.CUSTOMISE_YOUR_BOT) {
                    //do nothing
                } else {
                }
            }
            if(this.searchedData.length) {
                this.props.blockUiFun(false);
                this.toggleModal();
            } else {
                this.props.blockUiFun(false);
            }
            this.updateBot(this.props.editableBotData);
        }
    }

    updateBot = (botData) => {
        let timeOut;
        clearTimeout(timeOut);
        timeOut = setTimeout(() => {
            this.searchedData.forEach(elm => {
                this.props.updateBotValue(this.updateOnLocation( elm[Object.keys(elm)[0]], Object.keys(elm)[0], elm.parent, elm.parentData, botData))
            })
        }, 100)
    }

    updateOnLocation = (dataObj, dataKey, parentArray, parentData, botData) => {
        let currentData = botData;
        if(parentArray.length === 1) {
            currentData[parentArray[0]][dataKey] = dataObj;
        } else if(parentArray.length === 2) {
            if(parentArray[1] === "BOTID") {
                let tempBotElmData = {
                    "ELEM_TYPE": "text-field",
                    "ELEM_DESC": "BotID for ui",
                    "VALUE": this.props.selectedBotID
                }
                currentData[parentArray[0]][parentArray[1]] = tempBotElmData;
            } else {
                currentData[parentArray[0]][parentArray[1]][dataKey] = dataObj;
            }
        } else if(parentArray.length === 3) {
            currentData[parentArray[0]][parentArray[1]][parentArray[2]][dataKey] = dataObj;
        } else if(parentArray.length === 4) {
            currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][dataKey] = dataObj;
        } else if(parentArray.length === 5) {
            currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][dataKey] = dataObj;
        } else if(parentArray.length === 6) {
            currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][dataKey] = dataObj;
        } else if(parentArray.length === 7) {
            currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][dataKey] = dataObj;
        } else if(parentArray.length === 8) {
            currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][dataKey] = dataObj;
        } else if(parentArray.length === 9) {
            currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][dataKey] = dataObj;
        } else if(parentArray.length === 10) {
            currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]][dataKey] = dataObj;
        } else if(parentArray.length === 11) {
            currentData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]][parentArray[10]][dataKey] = dataObj;
        }
        return currentData;
    }

    searchInObject = (parent, oldObj, newObj) => {
        if(!oldObj || typeof oldObj === 'string' || !newObj) return;
        let keys = Object.keys(oldObj);
        for (let i = 0 ; i < keys.length ; i++) {
            let tempkeys = keys[i];
            let oldKeys = oldObj[tempkeys];
            let newKeys = newObj[tempkeys];
            let tempObj = {}
            let permittedParentArr = ['POST_OPTIONS', 'OPTIONS', 'SETTINGS', 'UI_OPTIONS', 'CHATBOT'];
            if(parent && parent.length && permittedParentArr.indexOf(parent[0]) > -1) {
                if ((typeof oldKeys == "string" || typeof oldKeys == "number" || typeof oldKeys == "boolean" || Array.isArray(oldKeys)) && (tempkeys !== 'ELEM_TYPE' && tempkeys !== 'ELEM_DESC')) {
                    // console.log('stringType',  typeof oldObj[tempkeys], oldObj[tempkeys], newObj[tempkeys]);
                    if ((oldKeys !== undefined) && (newKeys === undefined)) {
                        if(tempkeys) {
                            let tempBotElmData = {
                                "ELEM_TYPE": "text-field",
                                "ELEM_DESC": "BotID for ui",
                                "VALUE": this.props.selectedBotID
                            }
                            tempObj[tempkeys] = tempBotElmData;
                        } else {
                            tempObj[tempkeys] = oldKeys;
                        }
                        tempObj.parent = parent;
                        tempObj.parentData = oldKeys;
                        this.searchedData.push(tempObj);
                        // console.log('hello tempkeys -> ', tempkeys, parent);
                    }
                } else if (typeof oldKeys == "object") {
                    // console.log(oldObj[tempkeys], newObj[tempkeys]);
                    if ((oldKeys !== undefined) && (newKeys === undefined)) {
                        tempObj[tempkeys] = oldKeys;
                        tempObj.parent = parent;
                        this.searchedData.push(tempObj);
                        // console.log('hello selfKeys', tempkeys, oldKeys, parent);
                    }
                    this.searchInObject([...parent, tempkeys], oldKeys, newKeys)
                } else {
                    this.searchInObject([...parent, tempkeys], oldKeys, newKeys)
                }
            } else if(parent.length === 0){
                this.searchInObject([...parent, tempkeys], oldKeys, newKeys);
            }
        }
        return this.searchedData;
    }

    closeWindow = () => {
        this.toggleModal();
    }

    toggleModal = (currState = true) => {
        const { isOpen } = this.state;
        if(!currState) {
            document.getElementsByTagName('body')[0].style.overflow = 'auto';
            this.setState({isOpen: false});
        } else {
            document.getElementsByTagName('body')[0].style.overflow = isOpen
                ? 'auto'
                : 'hidden';
            this.setState(prevState => ({
                isOpen: !prevState.isOpen
            }));
        }
    };

    renderContent = () => {
        return (
            <div className = 'modal-body-content'>
                <h3>The following information are missing from the connector, It may happen due to new changes after the connector information last updated or, build. Those will be added once you press okay, and can be saved by clicking on save button</h3>
                <div className = 'outer-changes-container'>
                    {this.searchedData.map((elm, i) => {
                        let parrentval = elm.parent.toString();
                        parrentval = parrentval.replace(/,/g, ' -> ')
                        return (
                            <div className = 'inner-changes-container' key = {i}>
                                <hr></hr>
                                <h5 className = 'title-content'> Data Location : </h5>
                                <div className = 'content'>{parrentval}</div>
                                <h5 className = 'title-content'> Data : </h5>
                                <pre className = 'content'>
                                    {Object.keys(elm)[0]} : {JSON.stringify(elm[Object.keys(elm)[0]], null, 4)}
                                </pre>
                            </div>
                        )
                    })}
                </div>
            </div>
        );
    };

    render() {
        const { isOpen } = this.state;
        const header = {
            title: 'Flash Message',
            closeOnOutsideClick: false,
            // isRemoveCloseIcon : true,  // send if needed to hide close icon on header
            style: {
              // backgroundColor: 'red'
              display: 'none'
            }
        };
        const footer = {
            onSubmit: this.closeWindow,
            submitText: 'Okay',
            customStyle: {
                // backgroundColor:'blue'
                justifyContent: 'flex-end'
            },
            disableSubmit: false
        };
        const customStyle = {
            maxWidth: '750px'
        };
        const currSelectedTab = this.props.location.pathname.length && this.props.location.pathname.length > 1 && this.props.location.pathname.split('/')[2];

        const tabClass = 'tab-content bot-forge-tabs' + (this.props.editableBotData.botId && this.props.isCustomBot ? '' : ' cover-full-width') + (currSelectedTab === 'chatbot' ? ' bot-forge-home':'');
        return (
            <div className = {tabClass} id = 'botConfigTabs'>
                <div className = 'falsh-message-modal-container center'>
                    <Modal
                        isOpen={isOpen}
                        onClose={() => {this.toggleModal(false)}}
                        header={header}
                        footer={footer}
                        customStyle={customStyle}
                    >
                        {this.renderContent()}
                    </Modal>
                </div>
                <Switch>
                    <Route key = {1} path = {`/`} exact name = {'Empty'} render = {props => {return (<EmptyComp key = {this.props.selectedBotID} id = {this.props.id} />)}} />
                    <Route key = {12} path = {`/bot-list`} exact name = {'botlist'} render = {props => {return (<SelectionView props={props}/> )}} />
                    <Route key = {this.props.editableBotData._id} path = {`/:${this.props.selectedBotID}`} exact name = {'Default'} render = {props => {return (<DefaultComp key = {this.props.selectedBotID} id = {this.props.id}/>)}} />
                    <Route key = {3} path = {`/:${this.props.selectedBotID}/chatbot`} exact name = {'Chatbot'} render = {props => {return (<Dashboard checkNewUpdatedValues = {this.checkNewUpdatedValues}/> )}} />
                    <Route key = {4} path = {`/:${this.props.selectedBotID}/testingpagesettings`} exact name = {'TestingPageSettings'} render = {props => {return (<TestingComp botid = {this.props.selectedBotID} /> )}} />
                    <Route key = {5} path = {`/:${this.props.selectedBotID}/uisettings`} exact name = {'UiSettings'} render = {props => {return (<UiSettings botid = {this.props.selectedBotID} /> )}} />
                    <Route key = {6} path = {`/:${this.props.selectedBotID}/messagesettings`} exact name = {'MessagesSettings'} render = {props => {return (<MessagesText /> )}} />
                    <Route key = {7} path = {`/:${this.props.selectedBotID}/cards`} exact name = {'Cards'} render = {props => {return (<Cards /> )}} />
                    <Route key = {8} path = {`/:${this.props.selectedBotID}/images`} exact name = {'ImagesComp'} render = {props => {return (<ImagesComp /> )}} />
                    <Route key = {9} path = {`/:${this.props.selectedBotID}/framework`} exact name = {'Framework'} render = {props => {return (<Frameworks botId = {this.props.selectedBotID} currentTab = {this.props.currentActiveTab}/> )}} />
                    <Route key = {10} path = {`/:${this.props.selectedBotID}/customcss`} exact name = {'CustomCss'} render = {props => {
                        return (<CustomCss /> )
                    }}/>
                    <Route key = {10} path = {`/:${this.props.selectedBotID}/customjs`} exact name = {'CustomJs'} render = {props => {return (<CustomJs /> )}} />
                    <Route key = {11} path = {`/:${this.props.selectedBotID}/settings`} exact name = {'settings'} render = {props => {return (<Settings /> )}} />
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedBotID: state.UiReducer && state.UiReducer.selectedBotID ? state.UiReducer.selectedBotID : false,
        selectedBot: state.UiReducer && state.UiReducer.selectedBot && (state.UiReducer.selectedBot !== 'Select Bot') ? state.UiReducer.selectedBot : false,
        isCustomBot: state.UiReducer && state.UiReducer.isCustomBot ? state.UiReducer.isCustomBot : false,
        tabListArray: state.UiReducer && state.UiReducer.tabListArray && state.UiReducer.tabListArray.length ? state.UiReducer.tabListArray : [],
        currentActiveTab: state.UiReducer && state.UiReducer.currentActiveTab ? state.UiReducer.currentActiveTab : 'chatbot',
        genericBotData: state.UiReducer && state.UiReducer.genericBotData ? state.UiReducer.genericBotData : {},
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : false,
        currentLanguage: state.UiReducer && state.UiReducer.currentLanguage ? state.UiReducer.currentLanguage : 'en',
        availableBotList: state.UiReducer && state.UiReducer.availableBotList ? state.UiReducer.availableBotList : [],
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        toggleSideBar,
        updateCurrentTabStatus,
        updateBotValue,
        getGenericData,
        blockUiFun
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(BodyTabs));
